export enum StepperEnum {
    List,
    Single,
  }